import { applyMiddleware, compose, createStore, Store, StoreEnhancer } from 'redux'

import createSagaMiddleware from 'redux-saga'
import multi from 'redux-multi'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createBrowserHistory } from 'history'
import { routerMiddleware } from 'connected-react-router'

import rootReducer from './ducks/root.reducer'
import rootSaga from './ducks/root.saga'
import { IAuthState } from './ducks/auth/types'
import { ILayoutState } from './ducks/layout/types'
import { ISnackBarState } from './ducks/snack.bar/types'
import { IUserState } from './ducks/user/types'
import { IAssociatesState } from './ducks/user/associates/types'
import { IPatientState } from './ducks/patient/types'
import { IPatientTimeSeriesState } from './ducks/patient/timeseries/types'
import { IActivityState } from './ducks/patient/activity/types'
import { INoteState } from './ducks/patient/note/types'
import { ISleepState } from './ducks/patient/sleep/types'
import { IDeviceState } from './ducks/patient/device/types'
import { IReportState } from './ducks/patient/report/types'
import { IMedicalIndicatorState } from './ducks/patient/medical.indicator/types'
import { IPatientMetricsState } from './ducks/patient.metrics/types'

export interface IApplicationState {
    auth: IAuthState,
    layout: ILayoutState,
    snackBar: ISnackBarState,
    user: IUserState,
    associates: IAssociatesState,
    patient: IPatientState,
    timeseries: IPatientTimeSeriesState,
    activities: IActivityState,
    notes: INoteState,
    sleep: ISleepState,
    devices: IDeviceState,
    report: IReportState,
    medicalIndicators: IMedicalIndicatorState,
    patientMetrics: IPatientMetricsState
}

export const history = createBrowserHistory()

const sagaMiddleware = createSagaMiddleware()

const productionMode: boolean = `${process.env.REACT_APP_ENV || ''}` === 'production'

const middlewares: StoreEnhancer<any> = applyMiddleware(multi, sagaMiddleware, routerMiddleware(history))

const store: Store<IApplicationState> = createStore(
    rootReducer(history),
    /* composeWithDevTools is integration for plugin redux/devtools chrome.
    * see https://github.com/zalmoxisus/redux-devtools-extension
    * */
    productionMode ? compose(middlewares) : composeWithDevTools(middlewares)
)

sagaMiddleware.run(rootSaga)

export default store
